import React, { useState } from 'react';
import LoadingBar from 'react-top-loading-bar';
import './FileUploadUI.css';
// ... Your existing import statements ...

function FileUploadUI({ fileInput, loading, uploadFile, progress, uploadOption }) {

  const [uploadSuccess, setUploadSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const handleFileChange = () => {
    setUploadSuccess(false);
    setErrorMessage('');  // Clear the error message when a new file is selected
  };


  const handleUpload = () => {
    if (fileInput.current && fileInput.current.files.length === 0) {
      setErrorMessage('Please select a file before uploading.');
      return;
    }



    setErrorMessage('');  // Clear any previous error messages
    
    uploadFile().then(() => {
      setUploadSuccess(true);
    }).catch((err) => {
      // Extract a meaningful error message
      const errorMessage = err.response?.data?.message || err.message || 'An error occurred during the ETL process.';
      setErrorMessage(errorMessage);
      console.error('Upload failed:', err); // Log the full error for debugging
    });
  };



  return (
    <div className="upload-form">
      <LoadingBar
        color='#f11946'
        progress={progress}
        onLoaderFinished={() => progress}
        height={5}
      />
      {!uploadSuccess && !errorMessage && loading && (
        <div className="loading-component">
          <div className="loading-spinner"></div> {/* Spinner component */}
        </div>
      )}
      <p style={{ color: 'red' }}>{errorMessage}</p>

      {uploadSuccess && <p className="success-message">File uploaded successfully!</p>}


      <input
        className="upload-input"
        type="file"
        ref={fileInput}
        onChange={handleFileChange}

      />

      <button className={`upload-button ${uploadOption}`} onClick={handleUpload} disabled={loading}>Upload</button>
    </div>
  );
}

export default FileUploadUI;
